import { Component, OnInit } from '@angular/core';
import { RadnaKnjizica } from './radna-knjizica';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-radna-knjizica-modal-update',
  templateUrl: './radna-knjizica-modal-update.component.html'
})
export class RadnaKnjizicaModalUpdateComponent extends BaseModalUpdateComponent<RadnaKnjizica> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<RadnaKnjizica>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
